import { useState, useEffect, useContext } from "react";
import dispatchService from "services/dispatch.service";
import crudsService from "services/cruds-service";
import { AuthContext } from "context";


import Footer from "e4acomponents/Footer";
import DashboardLayout from "e4acomponents/LayoutContainers/DashboardLayout";
import DashboardNavbar from "e4acomponents/Navbars/DashboardNavbar";

import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";


import ViewDispatchesProducts from "../components/view-dispatches-products";
import {DispatchCard} from "../components/dispatchCard";

// Main component for viewing dispatches
export default function ViewDispatches({ }) {
    const [dispatches, setDispatches] = useState([]);
    const [cardsData, setCardsData] = useState([]);
    const [selectedDispatch, setSelectedDispatch] = useState(null);
    const [openProductsDialog, setOpenProductsDialog] = useState(false);
    const [user, setUser] = useState(null);
    const authContext = useContext(AuthContext);

    // Fetch dispatches on component mount
    useEffect(() => {
        (async () => {
            try {
                console.log("Breakpoint 1");
                const userId = await authContext.getCurrentUser();
                const currentUser = await crudsService.getUser(userId);
                setUser(currentUser.data);

                let dispatches = [];
                const org = currentUser.data.relationships.organizations;
                if (org) {
                    const dispatchesResponse = await dispatchService.getOrgDispatches(org.data[0].id);
                    dispatches = dispatchesResponse.data;
                } else {
                    const dispatchesResponse = await dispatchService.getDispatches();
                    dispatches = dispatchesResponse.data;
                }
                setDispatches(dispatches);
            } catch (error) {
                console.error("Error fetching dispatches for view:", error);
            }
        })();
    }, [])

    // Update cards data when dispatches change
    useEffect(() => {
        setCardsData(getCardsData(dispatches));
    }, [dispatches]);

    // Transforms dispatch data into card data
    const getCardsData = (dispatches) => {
        return dispatches.map((dispatch) => ({
            id: dispatch._id,
            dispatch_num: dispatch.dispatch_num,
            description: dispatch.description,
            organization: dispatch.organization.name,
            status: dispatch.status,
            productIds: dispatch.products,
            estimated_delivery_date: dispatch?.estimated_delivery_date || "no date provided",
            actual_delivery_date: dispatch?.actual_delivery_date || "no date provided",
            req_date: dispatch?.req_date || "no date provided"
        }));
    }

    // Handles opening the dispatch's products dialog
    const handleOpenProductsDialog = (dispatch) => {
        setSelectedDispatch(dispatch);
        setOpenProductsDialog(true);
    }

    // Handles closing the dispatch's products dialog
    const handleCloseProductsDialog = () => {
        setSelectedDispatch(null);
        setOpenProductsDialog(false);
    }

    return (
        <DashboardLayout>
            <DashboardNavbar />

            {/* View Dispatch's Products dialog */}
            <ViewDispatchesProducts
                open={openProductsDialog}
                handleClose={handleCloseProductsDialog}
                dispatch={selectedDispatch}
                productIds={selectedDispatch?.productIds || []}
            />

            <MDBox py={3}>

                {/* Page body */}
                <Grid container justifyContent="center" spacing={3}>
                    {cardsData.map((dispatch) => (
                        // Render a card for each dispatch
                        <Grid key={dispatch.id} item xs={12} md={8}>
                            <DispatchCard dispatch={dispatch} onViewProducts={() => handleOpenProductsDialog(dispatch)} />
                        </Grid>
                    ))}
                </Grid>

            </MDBox>

            <MDBox mt={3}>
                <Footer />
            </MDBox>
        </DashboardLayout>
    )
}